<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div
          v-if="is_popupview == null"
          class="flex items-center justify-between px-5 lg:px-10 pt-8"
        >
          <div>
            <h1 class="text-lg font-semibold">Assessments</h1>
          </div>
        </div>

        <div
          v-if="is_popupview == null"
          class="flex items-center gap-5 px-5 lg:px-10 pt-6 pb-10"
        >
          <button
            @click="
              (typeQuiz = 'course'), getQuiz();
              this.active_tab = 'Course Quiz';
            "
            :class="
              this.active_tab == 'Course Quiz'
                ? 'bg-blues text-white'
                : 'text-black bg-gray-100 hover:bg-slate-300'
            "
            class="font-semibold text-xs px-4 py-2 rounded-xl"
          >
            Module Assessment
          </button>
          <button
            @click="
              (typeQuiz = 'lesson'), getQuiz();
              this.active_tab = 'Lesson Quiz';
            "
            :class="
              this.active_tab == 'Lesson Quiz'
                ? 'bg-blues text-white'
                : 'text-black bg-gray-100 hover:bg-slate-300'
            "
            class="font-semibold text-xs px-4 py-2 rounded-xl hidden"
          >
            Lesson Quiz
          </button>
        </div>
        <div class="px-5 lg:px-10"   v-if="is_popupview == null">
          <div
            class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
          >
            <table
            
              class="min-w-full divide-y divide-gray-200 text-sm overflow-visible"
            >
              <thead class="bg-gray-50 text-blues">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Sl.No
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-left border-b border-r border-gray-200"
                  >
                    Assessment Title
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Start On
                  </th>

                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Student Attempt
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Total Attempt
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Preview
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Start
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Feedback
                  </th>
                </tr>
              </thead>
              <tbody v-if="loading">
                <tr class="w-full">
                  <td colspan="8" class="text-center py-6">
                    <div class="w-full flex justify-center items-center">
                      <img
                        src="@/assets/newd/loading.gif"
                        alt="Loading..."
                        class=""
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody
                v-else-if="this.published"
                class="divide-y divide-gray-200 bg-white text-sm"
              >
                <tr
                  v-for="(el, index) in this.published"
                  :key="el"
                  class="hover:bg-gray-50/75 transition-colors duration-150"
                >
                  <td
                    class="px-4 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                  >
                    {{ index + 1 }}
                  </td>

                  <td class="px-4 py-2 border-b text-center border-r">
                    <p
                      v-if="el.quiz"
                      class="text-left text-gray-900 whitespace-no-wrap"
                    >
                      {{ el.quiz.name }}
                    </p>
                    <p
                      v-else
                      class="text-center text-gray-900 whitespace-no-wrap"
                    >
                      empty
                    </p>
                  </td>
                  <td class="px-4 py-2 border-b text-center border-r border-t">
                    <p v-if="el.quiz.submitted_date != null">
                      {{ formatDate(el.quiz.submitted_date) }}
                    </p>
                    <p v-else>-</p>
                  </td>

                  <td class="px-4 py-2 border-b text-center border-r border-t">
                    <div v-if="el.quiz.question_attempt">
                      <p v-if="el.quiz.student_attempt != null">
                        {{ el.quiz.student_attempt }}
                      </p>
                      <p v-else>-</p>
                    </div>
                    <div v-else>No Attempt</div>
                  </td>

                  <!-- <td class="px-4 py-2 border-b text-center border-r border-t">
                    <div v-if="el.quiz.question_attempt">
                      <p v-if="el.quiz.question_attempt_count != null">
                        {{ el.quiz.question_attempt_count }}
                      </p>
                      <p v-else>-</p>
                    </div>
                    <div v-else>No Attempt</div>
                  </td> -->
                  <td class="px-4 py-2 border-b text-center border-r border-t">
  <span class="text-xs text-gray-500 font-medium">
    {{ el.quiz.quiz_published?.attempt ?? "-" }}
  </span>
</td>

                  <td class="px-4 py-2 border-b text-center border-r text-xs">
                    <div v-if="!el.quiz.question_attempt" class="py-2">
                      <div
                        class="cursor-pointer"
                        v-if="
                          el.quiz.qualify_certificate == true &&
                          el.quiz.quiztakers_set.completed == true
                        "
                        @click="
                          (is_popupview = el.quiz.id), quizPreview(el.quiz.id)
                        "
                      >
                        <div
                          class="mx-10 cursor-pointer rounded-lg flex justify-center gap-2 items-center py-2 px-4 bg-blues hover:bg-blue-600 text-white"
                        >
                          Preview
                        </div>
                      </div>

                      <div class="cursor-pointer" v-else>
                        <div class="text-black py-2 px-4 mx-10">
                          Not Submitted
                        </div>
                      </div>
                    </div>
                    <div v-else class="py-2">
                      <div
                        class="cursor-pointer"
                        v-if="el.quiz.student_attempt == 0"
                      >
                        <div class="text-black py-2 px-4 mx-10">
                          Not Submitted
                        </div>
                      </div>

                      <div
                        class="cursor-pointer"
                        v-else
                        @click="
                          (is_popupview = el.quiz.id), quizPreview(el.quiz.id)
                        "
                      >
                        <div
                          class="mx-10 cursor-pointer rounded-lg flex justify-center gap-2 items-center py-2 px-4 bg-blues hover:bg-blue-600 text-white"
                        >
                          Preview
                        </div>
                      </div>
                    </div>
                  </td>

                  <td
                    class="px-4 py-2 border-b text-center text-xs border-r"
                    :class="{ 'border-r': this.active_tab == 'Course Quiz' }"
                  >
                    <div v-if="!el.quiz.question_attempt">
                      <div
                        v-if="
                          el.quiz.qualify_certificate == true &&
                          el.quiz.quiztakers_set.completed != true
                        "
                        class="flex items-center justify-center text-xs"
                      >
                        <router-link
                          v-if="canStartQuiz(el)"
                          class="mx-10 cursor-pointer rounded-lg font-bold flex justify-center gap-2 py-2 px-4 hover:text-teal-500 text-black"
                          style="border: 1px solid #01b0f9"
                          :to="{
                            name: 'QuizTest',
                            params: {
                              course_id: this.course_id,
                              quiz_id: el.quiz.id,
                            },
                          }"
                        >
                          Start
                        </router-link>
                        <span v-else class="text-gray-400 py-2 px-4 mx-10 block">
                          Not Published
                        </span>
                      </div>

                      <p v-else>Completed</p>
                    </div>

                    <div v-else>
                       <!-- el.quiz.question_attempt_count -->
                      <div
                        v-if="
                          el.quiz.student_attempt ==
                          el.quiz.quiz_published?.attempt
                        "
                      >
                        <div class="text-black py-2 px-4 mx-10">
                          No attempt balance
                        </div>
                      </div>
                      <div
                        class="cursor-pointer flex items-center justify-center text-xs"
                        v-else
                      >
                        <router-link
                          v-if="canStartQuiz(el)"
                          class="mx-10 cursor-pointer rounded-lg font-bold flex justify-center gap-2 py-2 px-4 hover:text-teal-500 text-black"
                          style="border: 1px solid #01b0f9"
                          :to="{
                            name: 'QuizTest',
                            params: {
                              course_id: this.course_id,
                              quiz_id: el.quiz.id,
                            },
                          }"
                        >
                          Start
                        </router-link>
                        <span v-else class="text-gray-400 py-2 px-4 mx-10 block">
                          Not Published
                        </span>
                      </div>
                    </div>
                  </td>

                  <td class="px-4 py-2 border-b text-center text-xs border-r">
                    <div v-if="el.quiz.is_active">
                      <div v-if="el.quiz.quiztakers_set.completed == true">
                        <button
                          v-if="el.quiz.quiz_feedback.user_feedback == null"
                          class="bg-blues text-white rounded-md hover:bg-blue-600 px-2 py-1 text-xs"
                          @click.stop="feedbackPopup = el.quiz.id"
                        >
                          Give Feedback
                        </button>

                        <button
                          v-if="el.quiz.quiz_feedback.user_feedback != null"
                          @click.stop="getfeedback(el.quiz.id)"
                          class="gap-1 px-2 py-1 bg-blues rounded-md text-white hover:bg-blue-600 transition-all"
                          title="View Full Description"
                        >
                          <span class="text-xs font-medium">View Feedback</span>
                        </button>
                      </div>
                      <div v-else>----</div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="w-full">
                  <td colspan="8" class="text-center py-6">NO Data Found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          class="flex flex-col gap-10 p-5 md:p-10"
          v-if="is_popupview != null && quizPreviewId == null"
        >
          <div
            class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-4"
          >
            <!-- Left Content -->
            <div class="space-y-1 text-center sm:text-left">
              <h2 class="text-lg sm:text-xl font-bold text-slate-900">
                Quiz Attempts
              </h2>

              <p class="text-xs sm:text-sm text-slate-500">
                Showing all completed submissions (<span class="font-semibold"
                  >Total:</span
                >
                <span class="font-bold text-blue-600">{{ dataval.length }}</span
                >)
              </p>
            </div>

            <!-- Back Button -->
            <div class="flex justify-end sm:justify-start">
              <button
                @click="is_popupview = null"
                class="bg-blues hover:bg-blue-600 text-white px-4 font-semibold text-sm py-1 rounded-xl"
              >
                Back
              </button>
            </div>
          </div>
          <div
            class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
          >
            <table
              class="min-w-full divide-y divide-gray-200 text-sm overflow-visible"
            >
              <thead class="bg-gray-50 text-blues">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Sl.No
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-left border-b border-r border-gray-200 min-w-[150px]"
                  >
                    Assessment Title
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Score
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200 whitespace-nowrap"
                  >
                    Total Score
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-2.5 font-semibold text-center border-b border-r border-gray-200"
                  >
                    Quiz
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white text-sm">
                <tr
                  v-for="(el, index) in this.dataval"
                  :key="el"
                  class="hover:bg-gray-50/75 transition-colors duration-150"
                >
                  <td
                    class="px-4 py-3 border-r border-gray-200 text-center whitespace-nowrap"
                  >
                    {{ index + 1 }}
                  </td>

                  <td
                    class="px-6 py-3 border-r border-gray-200 text-left whitespace-nowrap"
                  >
                    {{ el.quiz.name }}
                  </td>
                  <td
                    class="px-6 py-3 border-r border-gray-200 text-center whitespace-nowrap"
                  >
                    <p v-if="el.score != null">{{ el.score }}</p>
                    <p v-else>-</p>
                  </td>

                  <td
                    class="px-6 py-3 border-r border-gray-200 text-center whitespace-nowrap"
                  >
                    <div v-if="el.quiz.max_value === 0">
                      <p v-if="el.quiz.total_score != null">
                        {{ el.quiz.total_score }}
                      </p>
                      <p v-else>-</p>
                    </div>
                    <div v-else>
                      <p v-if="el.quiz.max_value">
                        {{ el.quiz.max_value }}
                      </p>
                    </div>
                  </td>
                  <td
                    class="px-6 py-3 border-r border-gray-200 text-center whitespace-nowrap"
                  >
                    <p v-if="el.finished_at != null">
                      {{ formatDateTime(el.finished_at) }}
                    </p>
                    <p v-else>-</p>
                  </td>

                  <td
                    class="px-6 py-3 border-r border-gray-200 text-center whitespace-nowrap"
                  >
                    <button
                      @click="(quizPreviewId = el.id), quizPreviewbyId(el.id)"
                      class="text-blue-600 hover:text-blue-800 hover:underline font-medium transition-colors"
                    >
                      Preview
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- old Preview -->
        <div
          v-if="quizPreviewId != null"
          style="background-color: white !important"
          class="bg-white rounded-2xl hidden"
        >
          <div class="mx-auto relative m-4 p-8 rounded-md">
            <div
              v-if="currentQuizValue[0]"
              class="w-full lg:p-4 mx-auto lg:w-12/12 relative text-center text-xl font-semibold"
            >
              {{ currentQuizValue[0].quiz.name }}
              <div class="absolute right-8 top-8">
                <div
                  @click="quizPreviewId = null"
                  class="cursor-pointer rounded-lg flex border justify-center w-24 gap-2 items-center py-1 bg-white"
                >
                  <div
                    class="text-sm text-gray-700 hover:text-teal-500"
                    title="back"
                  >
                    back
                  </div>
                  <div class="flex items-center">
                    <img
                      src="https://img.icons8.com/external-simple-solid-edt.graphics/15/undefined/external-Back-arrows-simple-solid-edt.graphics-2.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pb-10" v-if="currentQuizValue[0]">
            <div
              v-for="(el, index) in currentQuizValue[0]
                .coursequizusersanswer_set"
              :key="el"
              class="border max-w-4xl mx-auto mt-4 text-start p-10 rounded-3xl"
            >
              <p class="py-2 font-bold">
                {{ index + 1 }}) {{ el.question.question_text }}
              </p>
              <!-- <pre> {{ el }}</pre> -->
              <div
                v-if="el.question.choice_type === 'coding'"
                class="px-6 mt-6 py-6 rounded-2xl my-2"
              >
                <div
                  class="w-full bg-gray-900 text-white rounded-lg overflow-hidden"
                >
                  <!-- Header -->
                  <div
                    class="flex justify-between items-center px-5 py-3 bg-gray-800 border-b border-gray-700"
                  >
                    <div class="flex items-center gap-4">
                      <h3 class="text-sm font-semibold">Code Editor</h3>
                      <input
                        type="text"
                        :value="el.question.programming_language"
                        class="px-3 py-1.5 border border-gray-700 rounded bg-gray-700 text-white text-xs outline-none cursor-not-allowed"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="flex" style="height: 400px">
                    <!-- Left Side - Code Editor -->
                    <div
                      class="flex-1 flex flex-col overflow-hidden border-r border-gray-700"
                    >
                      <div
                        class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                      >
                        <span>📝 Submitted Code</span>
                      </div>

                      <MonacoEditor
                        :value="el.coding || '// No code submitted'"
                        :language="el.question.programming_language"
                        height="100%"
                        theme="vs-dark"
                        :options="{
                          readOnly: true,
                          minimap: { enabled: false },
                          scrollBeyondLastLine: false,
                          fontSize: 13,
                          lineNumbers: 'on',
                          glyphMargin: false,
                          lineDecorationsWidth: 0,
                          lineNumbersMinChars: 3,
                          renderLineHighlight: 'none',
                          contextmenu: false,
                          cursorStyle: 'line-thin',
                        }"
                        class="flex-1"
                      />
                    </div>

                    <!-- Right Side - Output -->
                    <div class="flex-1 flex flex-col overflow-hidden">
                      <div
                        class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                      >
                        <span>📤 Output</span>
                      </div>
                      <div class="flex-1 p-4 overflow-y-auto bg-gray-900">
                        <div
                          v-if="el.output"
                          class="font-mono text-xs whitespace-pre-wrap leading-relaxed text-gray-300"
                        >
                          {{ formatOutput(el.output) }}
                        </div>
                        <div
                          v-else
                          class="text-gray-500 italic text-center mt-12 text-xs"
                        >
                          No output available
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- changes need to do..-->
              <div
                v-if="
                  el.question.choice_type === 'choice' ||
                  el.question.choice_type === 'truefalse'
                "
              >
                <div
                  v-for="(al, index) in el.question.coursequizanswer_set"
                  :key="al"
                >
                  <p
                    class=""
                    :class="[
                      al.is_correct == true ? 'text-blue-900 font-bold' : '',
                    ]"
                  >
                    {{ index + 1 }}) {{ al.answer_text }} <br />
                  </p>
                </div>

                <div class="px-6 mt-6 py-6 rounded-2xl border my-2">
                  <h1
                    class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
                  >
                    Your Answer
                  </h1>
                  <p
                    v-if="el.answer"
                    class="px-4 text-sm font-bold"
                    :class="[
                      el.answer.is_correct == true
                        ? 'text-green-700'
                        : 'text-red-400',
                    ]"
                  >
                    {{ el.answer.answer_text }}
                  </p>
                  <p v-else class="px-4 text-sm font-bold">Not attend</p>
                </div>
              </div>

              <div
                v-if="el.question.choice_type === 'description'"
                class="px-6 mt-6 py-6 rounded-2xl border my-2"
              >
                <h1
                  class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
                >
                  Your Answer
                </h1>
                <p
                  v-if="el.description != null"
                  class="px-4 text-sm font-bold mt-2"
                >
                  {{ el.description }}
                </p>
              </div>

              <div
                v-if="el.question.choice_type === 'shortdescription'"
                class="px-6 mt-6 py-6 rounded-2xl border my-2"
              >
                <h1
                  class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
                >
                  Your Answer
                </h1>
                <p
                  v-if="el.short_description != null"
                  class="px-4 text-sm font-bold mt-2"
                >
                  {{ el.short_description }}
                </p>
              </div>

              <div
                class="flex flex-col flex-wrap justify-center gap-4 w-full"
                v-if="el.question.choice_type == 'matchthefollowing'"
              >
                <div class="grid grid-cols-2 gap-10 pt-5">
                  <div class="flex flex-col gap-2">
                    <div
                      v-for="left_items in el.match_answer.left_items"
                      :key="left_items"
                      class="text-sm px-5 py-2 bg-gray-100"
                    >
                      Question: {{ left_items.value }}
                    </div>
                  </div>
                  <draggable
                    :list="el.match_answer.right_items"
                    class="dragArea list-group w-full flex flex-col gap-2"
                  >
                    <div
                      v-for="right_items in el.match_answer.right_items"
                      :key="right_items"
                      class="text-sm px-5 py-2 bg-gray-200 cursor-pointer"
                    >
                      {{ right_items.value }}
                    </div>
                  </draggable>
                </div>

                <br />
              </div>
            </div>
          </div>
        </div>
        <!-- new preview -->
        <div
          v-if="quizPreviewId != null"
          class="bg-gray-50/50 min-h-screen pb-12 px-4 sm:px-6"
        >
          <div
            v-if="currentQuizValue && currentQuizValue[0]"
            class="max-w-4xl mx-auto pt-6"
          >
            <div
              class="bg-white border border-gray-100 rounded-3xl p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm"
            >
              <div class="space-y-0.5 text-start flex-1 min-w-0">
                <h1
                  class="text-lg sm:text-xl font-extrabold text-gray-900 tracking-tight pt-1 truncate"
                >
                  {{ currentQuizValue[0].quiz?.name }}
                </h1>
              </div>

              <button
                @click="quizPreviewId = null"
                class="bg-blues hover:bg-blue-600 text-white px-4 font-semibold text-sm py-1 rounded-xl"
              >
                Back
              </button>
            </div>
          </div>

          <div
            v-if="currentQuizValue && currentQuizValue[0]"
            class="max-w-4xl mx-auto grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4 my-6"
          >
            <div
              class="bg-blue-50 border border-blue-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-[10px] sm:text-xs font-semibold text-blue-600 uppercase tracking-wider"
              >
                Total Qns
              </p>
              <p class="text-xl sm:text-2xl font-black text-blue-900 mt-1">
                {{ currentQuizValue[0].coursequizusersanswer_set.length }}
              </p>
            </div>

            <div
              class="bg-green-50 border border-green-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-[10px] sm:text-xs font-semibold text-green-600 uppercase tracking-wider"
              >
                Correct
              </p>
              <p class="text-xl sm:text-2xl font-black text-green-900 mt-1">
                {{
                  currentQuizValue[0].coursequizusersanswer_set.filter(
                    (el) => el.answer?.is_correct,
                  ).length
                }}
              </p>
            </div>

            <div
              class="bg-red-50 border border-red-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-[10px] sm:text-xs font-semibold text-red-600 uppercase tracking-wider"
              >
                Wrong
              </p>
              <p class="text-xl sm:text-2xl font-black text-red-900 mt-1">
                {{
                  currentQuizValue[0].coursequizusersanswer_set.filter(
                    (el) => el.answer && !el.answer.is_correct,
                  ).length
                }}
              </p>
            </div>

            <div
              class="bg-gray-50 border border-gray-200 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-[10px] sm:text-xs font-semibold text-gray-500 uppercase tracking-wider"
              >
                Skipped
              </p>
              <p class="text-xl sm:text-2xl font-black text-gray-700 mt-1">
                {{
                  currentQuizValue[0].coursequizusersanswer_set.filter(
                    (el) => !el.answer,
                  ).length
                }}
              </p>
            </div>

            <div
              class="bg-purple-50 border border-purple-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-[10px] sm:text-xs font-semibold text-purple-600 uppercase tracking-wider"
              >
                My Score
              </p>
              <p class="text-xl sm:text-2xl font-black text-purple-900 mt-1">
                {{
                  Number(
                    currentQuizValue[0].coursequizusersanswer_set.reduce(
                      (acc, el) => acc + (Number(el.mark) || 0),
                      0,
                    ),
                  )
                }}
              </p>
            </div>

            <div
              class="bg-amber-50 border border-amber-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-[10px] sm:text-xs font-semibold text-amber-600 uppercase tracking-wider"
              >
                Max Score
              </p>
              <p class="text-xl sm:text-2xl font-black text-amber-900 mt-1">
                {{
                  Number(
                    currentQuizValue[0].coursequizusersanswer_set.reduce(
                      (acc, el) => acc + (Number(el.question?.max_mark) || 0),
                      0,
                    ),
                  )
                }}
              </p>
            </div>
          </div>

          <div
            class="pb-10 max-w-4xl mx-auto"
            v-if="currentQuizValue && currentQuizValue[0]"
          >
            <div
              v-for="(el, index) in currentQuizValue[0]
                .coursequizusersanswer_set"
              :key="index"
              class="bg-white border border-gray-200 shadow-sm rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 mt-4 text-start transition-all hover:shadow-md"
            >
              <div
                class="flex flex-col sm:flex-row sm:items-start justify-between gap-3 border-b border-gray-100 pb-4"
              >
                <h3
                  class="text-sm sm:text-base font-bold text-gray-900 leading-relaxed flex-1"
                >
                  <span class="text-gray-400 mr-1">{{ index + 1 }}.</span>
                  {{ el.question.question_text }}
                </h3>

                <div class="flex items-center shrink-0">
                  <span
                    v-if="el.mark != null || el.question.max_mark != null"
                    class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-[11px] sm:text-xs font-semibold bg-gray-50 border border-gray-200 text-gray-600 shadow-sm whitespace-nowrap"
                  >
                    <span>Score:</span>
                    <span
                      :class="[
                        Number(el.mark ?? 0) > 0
                          ? 'text-green-600 font-extrabold'
                          : 'text-gray-400 font-bold',
                      ]"
                    >
                      {{ Number(el.mark ?? 0) }}
                    </span>
                    <span class="text-gray-400 font-normal">/</span>
                    <span class="text-blue-700 font-extrabold">
                      {{ Number(el.question.max_mark ?? 0) }}
                    </span>
                  </span>
                </div>
              </div>

              <div
                v-if="el.question.choice_type === 'choice'"
                class="mt-4 space-y-2"
              >
                <div
                  v-for="(al, aIndex) in el.question.coursequizanswer_set"
                  :key="aIndex"
                  class="flex items-start sm:items-center p-3 rounded-xl border text-xs sm:text-sm transition-colors gap-2"
                  :class="[
                    al.is_correct
                      ? 'bg-blue-50/50 border-blue-200 text-blue-950 font-semibold'
                      : 'border-gray-100 text-gray-600',
                  ]"
                >
                  <span
                    class="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full text-[10px] sm:text-xs shrink-0 mt-0.5 sm:mt-0"
                    :class="
                      al.is_correct
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-100 text-gray-500'
                    "
                  >
                    {{ String.fromCharCode(65 + aIndex) }}
                  </span>

                  <span class="flex-1 min-w-0 break-words">{{
                    al.answer_text
                  }}</span>

                  <span
                    v-if="al.is_correct"
                    class="ml-auto text-[10px] sm:text-xs font-bold text-blue-600 uppercase tracking-wider shrink-0 pl-1"
                  >
                    Correct
                  </span>
                </div>

                <div class="mt-4 sm:mt-6">
                  <div
                    v-if="el.answer"
                    class="flex items-start sm:items-center gap-3 p-3 sm:p-4 rounded-xl sm:rounded-2xl border"
                    :class="[
                      el.answer.is_correct
                        ? 'bg-green-50 border-green-200 text-green-900'
                        : 'bg-red-50 border-red-200 text-red-900',
                    ]"
                  >
                    <div
                      class="p-1.5 sm:p-2 rounded-lg sm:rounded-xl bg-white shadow-sm shrink-0 mt-0.5 sm:mt-0"
                    >
                      <svg
                        v-if="el.answer.is_correct"
                        class="w-4 h-4 sm:w-5 sm:h-5 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.5"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                      <svg
                        v-else
                        class="w-4 h-4 sm:w-5 sm:h-5 text-red-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2.5"
                          d="M6 18L18 6M6 6l12 12"
                        ></path>
                      </svg>
                    </div>
                    <div class="min-w-0 flex-1">
                      <p
                        class="text-[10px] sm:text-xs font-semibold text-gray-400 uppercase tracking-wider"
                      >
                        Your Answer
                      </p>
                      <p
                        class="text-xs sm:text-sm font-bold mt-0.5 break-words"
                      >
                        {{ el.answer.answer_text }}
                      </p>
                    </div>
                  </div>

                  <div
                    v-else
                    class="flex items-center gap-3 p-3 sm:p-4 rounded-xl sm:rounded-2xl border border-dashed border-gray-300 bg-gray-50 text-gray-500"
                  >
                    <svg
                      class="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <div>
                      <p
                        class="text-[10px] sm:text-xs font-semibold text-gray-400 uppercase tracking-wider"
                      >
                        Your Answer
                      </p>
                      <p class="text-xs sm:text-sm font-bold mt-0.5">
                        Not Attended
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="this.feedbackPopup != null"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto"
      >
        <div
          class="flex items-center justify-between p-6 border-b border-gray-100"
        >
          <h3 class="text-xl font-bold text-blue-600">Submit Feedback</h3>
          <button
            @click="closeFeedbackModal"
            class="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center"
          >
            <svg
              class="w-5 h-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div class="p-6">
          <form
            ref="submitfeedback"
            @submit.prevent="scheduleFeedback"
            class="space-y-6"
          >
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700">
                Description <span class="text-red-500">*</span>
              </label>
              <textarea
                v-model="description"
                rows="4"
                minlength="10"
                required
                class="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 resize-none"
                placeholder="Share your thoughts about this class..."
              ></textarea>
              <p
                v-if="description && description.trim().length < 10"
                class="text-red-500 text-sm"
              >
                Description must be at least 10 characters.
              </p>
            </div>
            <div class="flex flex-col w-full gap-2">
              <!-- Label -->
              <label
                for="rating"
                class="text-left text-sm font-medium text-gray-700"
              >
                Rating <span class="text-red-400">*</span>
              </label>

              <!-- Star Rating Preview -->
              <div id="rating" class="flex items-center gap-1">
                <template v-for="i in 5" :key="i">
                  <svg
                    @click="setRating(i)"
                    :class="[
                      'w-6 h-6 cursor-pointer transition-colors duration-200',
                      i <= selectedRating ? 'text-yellow-400' : 'text-gray-300',
                    ]"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                    />
                  </svg>
                </template>
              </div>
            </div>
            <div class="flex justify-end items-center gap-3 pb-4 mt-3">
              <button
                v-if="selectedRating"
                type="submit"
                :disabled="disable_submit == true"
                :class="
                  disable_submit == true
                    ? 'bg-gray-200 text-black cursor-not-allowed'
                    : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                "
                class="rounded-lg text-sm px-10 py-2"
              >
                Submit
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-6 h-6 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="feedbackModalOpen != null"
      class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative"
      >
        <!-- Modal Header -->
        <div
          class="flex items-center justify-between p-5 border-b border-gray-200"
        >
          <h2 class="text-xl font-semibold text-gray-800">
            Assessment Feedback
          </h2>
          <button
            @click="feedbackModalOpen = null"
            class="text-gray-500 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>
        <!-- Modal Body -->
        <!-- <h2 class="text-lg font-semibold text-gray-800 mb-4">
              Feedback Details
            </h2> -->

        <!-- Description -->
        <div class="mb-4 px-5 pt-5">
          <label class="text-sm font-medium text-gray-600 block mb-1">
            Description:
          </label>
          <p class="text-gray-700 text-sm whitespace-pre-wrap">
            {{ feedback.text || "No description provided." }}
          </p>
        </div>

        <!-- Star Rating -->
        <div class="mb-4 px-5">
          <label class="text-sm font-medium text-gray-600 block mb-1">
            Rating:
          </label>
          <div class="flex items-center gap-1">
            <template v-for="i in 5" :key="i">
              <svg
                :class="[
                  'w-6 h-6 transition',
                  i <= feedback.rating ? 'text-yellow-400' : 'text-gray-300',
                ]"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                />
              </svg>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import SideBar from "@/components/Student/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import MonacoEditor from "monaco-editor-vue3";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    MonacoEditor,
  },
  data() {
    return {
      dataval: "",
      is_popupview: null,
      published: "",
      quiz_id: 0,
      currentQuestion: 0,
      score: 0,
      languages: ["python", "c", "cpp"],
      percentage: 0,
      countDown: 30,
      timer: null,
      startindex: "",
      startQuiz: false,
      completed: false,
      message: "Congrats, Your are Completed Course Quiz.",
      HeaderVal: "",
      list_data: [],
      messages: {
        text: "",
        type: "null",
      },
      quiz_details: "",
      loading: true,
      typeQuiz: "course",
      generalquiz: [],
      active_tab: "Course Quiz",
      quizPreviewId: null,
      currentQuizValue: [],
      feedbackPopup: null,
      feedbackModalOpen: null,
      selectedRating: 0,
      feedback: "",
      disable_submit: false,
      description: "",
    };
  },
  created() {
    if (this.$route.query.tab === "lesson") {
      this.active_tab = "Lesson Quiz";
      this.typeQuiz = "lesson";
    }

    if (this.$route.query.quiz_id) {
      const quizId = this.$route.query.quiz_id;
      this.quizPreview(quizId);
    }

    this.getQuiz();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    closeFeedbackModal() {
      this.feedbackPopup = null;
      this.selectedRating = "";
      this.description = "";
    },
    formatDateTime(date) {
      const d = new Date(date);

      const formattedDate = d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      const formattedTime = d
        .toLocaleTimeString("en-IN", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })
        .toLowerCase(); // makes "PM" → "pm"

      return `${formattedDate} - ${formattedTime}`;
    },
    // quiz_data() {
    //   this.is_popupview = false;
    // },
    formatOutput(output) {
      try {
        ``;
        const outputArray = JSON.parse(output);

        return outputArray.join("\n");
      } catch (e) {
        return output;
      }
    },
    async scheduleFeedback() {
      this.disable_submit = true;
      let bodyVal = {
        quize: this.feedbackPopup,
        text: this.description,
        rating: this.selectedRating,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/quiz-feedback/create/?Key=${this.userInfo.token_key}`,
          bodyVal,
        )
        .then((response) => {
          if (response.data.status == 201) {
            this.messages = {
              text: "Feedback Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitfeedback.reset();
              this.feedbackPopup = null;
              // this.deatilfeedback = true;
              this.disable_submit = false;
              this.selectedRating = "";
              this.description = "";
              this.getQuiz();
              // this.getfeedback(this.assignmentId);
              // this.getdetails(1);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2500);
          }
        });
    },

    async getfeedback(id) {
      this.feedback = "";
      this.feedbackModalOpen = id;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiz-feedback/update/delete/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.feedback = res.data.data[0];
          }
        });
    },

    setRating(rating) {
      this.selectedRating = rating;
    },

    openfeedback(id) {
      this.feedbackModalOpen = id;
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },

    canStartQuiz(el) {
      if (this.typeQuiz !== "course") return true;
      return el.quiz?.quiz_published?.published === true;
    },

    async quizPreview(id) {
      // this.is_popupview = true;
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}&user__id=${this.userInfo.user.id}`,
        )

        .then((response) => {
          if (response.data.status == 200) {
            this.dataval = response.data.data;
          } else {
            console.log("Something went wrong");
          }
          // console.log("response::", response.data.data);
        });

      // await axios
      //   .get(
      //     `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`
      //   )
      //   .then((response) => {
      //     this.dataval = response.data.data;
      //     console.log("response::", response.data.data);
      //   });
    },

    async quizPreviewbyId(id) {
      // this.is_popupview = false;
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.is_popupview}/?Key=${token}&id=${id}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.currentQuizValue = response.data.data;
          } else {
            console.log("Something went wrong");
          }
          // console.log("response::", response.data.data);
        });

      // await axios
      //   .get(
      //     `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`
      //   )
      //   .then((response) => {
      //     this.dataval = response.data.data;
      //     console.log("response::", response.data.data);
      //   });
    },

    async getQuiz() {
      this.quiz_details = [];
      if (this.typeQuiz == "course") {
        if (this.userInfo) {
          let token = this.userInfo.token_key;
          // console.log(
          //   `${process.env.VUE_APP_API}/course_quizzes_detail/${this.course_id}/?Key=${token}`
          // );
          await axios
            .get(
              `${process.env.VUE_APP_API}/course_quizzes_detail/${this.course_id}/?Key=${token}&qualify_certificate=true`,
            )
            .then((response) => {
              if (response.data.error == "No Quiz found for this course") {
                console.log("Event Faild");
                // this.messages = {
                //   text: "No Quiz found for this course",
                //   type: "error",
                // };
              } else {
                this.published = response.data.data;
                this.loading = false;

                // this.published = response.data.data[0].quiz.qualify_certificate
                this.quiz_details = response.data.data;
                console.log("index_data::", this.index_data);
                this.questions =
                  response.data.data[0].quiz.coursequizquestion_set;
                console.log("this.questions", this.questions);

                console.log("response.data.data", response.data.data);
                console.log(
                  "response.data.data",
                  response.data.data[0].quiz.qualify_certificate,
                );
                console.log("quiz values", this.quiz_details.quiz);
                if (
                  response.data.data[0].quiz.quiztakers_set.completed == true
                ) {
                  this.completed = true;
                }
              }
              if (response.data.status == 400) {
                this.loading = false;
              }
            });
        }
      }
      if (this.typeQuiz == "lesson") {
        await axios
          .get(
            `${process.env.VUE_APP_API}/lesson_quizzes_detail/${this.course_id}/?Key=${this.userInfo.token_key}&qualify_certificate=True`,
          )
          .then((response) => {
            if (response.data.data) {
              this.quiz_details = response.data.data;
              this.loading = false;
              this.published = response.data.data;
              this.loading = false;
              // this.published = response.data.data[0].quiz.qualify_certificate
              this.quiz_details = response.data.data;
              // this.published = this.generalquiz;
              // console.log(this.published);
            } else if (response.data.status == 400) {
              this.loading = false;
            }
          });
      }
    },
    startQuizFunc(index, quiz_title_data) {
      this.questions = this.quiz_details[index].quiz.coursequizquestion_set;
      this.quiz_title = quiz_title_data;
      this.startQuiz = true;
    },

    handleAnswerClick(question_id, answer_id, isCorrect) {
      console.log(question_id, answer_id, isCorrect);
      if (question_id != false) {
        this.list_data.push({
          question: question_id,
          answer: answer_id,
        });
      }

      clearTimeout(this.timer);
      let nextQuestion = this.currentQuestion + 1;
      if (isCorrect) {
        this.score = this.score + 1;
        console.log("this.score", this.score);
        // this.percentage = (this.score / this.questions.length) * 100;
      }
      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;

        this.countDown = 30;
        // this.countDownTimer();
      } else {
        this.completed = true;
        this.saveQuizResult();
      }
    },
    async saveQuizResult() {
      this.HeaderVal = {
        score: this.score,
        quiz: this.course_id,
        quiz_title: this.quiz_title,
        usersanswer: this.list_data,
        completed: true,
      };
      console.log("post_befer __ this.HeaderVal:::", this.HeaderVal);
      if (this.userInfo) {
        let token = this.userInfo.token_key;
        console.log(
          `${process.env.VUE_APP_API}/course_save_multi_answer/?Key=${token}`,
          this.HeaderVal,
        );
        await axios
          .patch(
            `${process.env.VUE_APP_API}/course_save_multi_answer/?Key=${token}`,
            this.HeaderVal,
          )
          .then((response) => {
            console.log("response", response);
            console.log("response", response.data);
            if (response.data.message == "Course Answer updated successfully") {
              this.messages = {
                text: "Congrats, Your are Completed Course Quiz.",
                type: "success",
              };
            } else {
              this.messages = {
                text: " Event Faild",
                type: "error",
              };
            }
          });
        setTimeout(() => {
          this.messages = {
            text: " ",
            type: "null",
          };
          location.reload();
          this.getQuiz();
        }, 200);
      }

      console.log("user answer quiz saved");
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
